import React from "react";
import { HStack, VStack } from "native-base";
import { Link, Outlet } from "react-router-dom";
import colors from "../../constants/colors";
import logo from "../../assets/images/logo_simple.png";
import routes from "../../routes";
import Image from "../../components/image";

function SignUpLayout() {
  return (
    <VStack paddingBottom={20}>
      <HStack paddingX={16} paddingY={5} backgroundColor={colors.primary}>
        <Link to={routes.home}>
          <Image image={logo} alt="logo" height={60} width={150} />
        </Link>
      </HStack>
      <Outlet />
    </VStack>
  );
}

export default SignUpLayout;
